module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"@south-paw/covid-19","short_name":"@south-paw/covid-19","start_url":"/","background_color":"#EBE0CD","theme_color":"#EA6F29","display":"minimal-ui","icon":"src/images/icon.png"},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-161565812-1","head":false,"anonymize":false,"respectDNT":false},
    }]
